import { Box, Skeleton, useMediaQuery } from '@mui/material';

export const SkeletonChatList = () => (
  <Box sx={{ width: '100%', padding: 2 }}>
    {[...Array(5)].map((_, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: 2,
          justifyContent: index % 2 === 0 ? 'flex-end' : 'flex-start',
        }}
      >
        {index % 2 === 0 ? null : <Skeleton variant="circular" width={30} height={30} sx={{ marginRight: 2 }} />}
        <Box sx={{ width: '100%' }}>
          <SkeletonStamp isOwnMessage={index % 2 === 0} />
          <SkeletonLinkPreview isOwnMessage={index % 2 === 0} />
          <SkeletonChatBubble isOwnMessage={index % 2 === 0} />
        </Box>
      </Box>
    ))}
  </Box>
);

const SkeletonStamp = ({ isOwnMessage }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: isOwnMessage ? 'flex-end' : 'flex-start' }}>
    <Skeleton
      variant="text"
      width="30%"
      height={20}
      sx={{
        marginBottom: 1,
      }}
    />
  </Box>
);

const SkeletonChatBubble = ({ isOwnMessage }) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: 3,
      backgroundColor: isOwnMessage ? '#EEF5FF' : '#EEF5FF',
      padding: '8px 12px',
      width: '30vw',
      maxWidth: '85%',
      wordWrap: 'break-word',
      marginLeft: isOwnMessage ? 'auto' : 0,
      marginRight: isOwnMessage ? 0 : 'auto',
      borderTopRightRadius: isOwnMessage ? 0 : null,
      borderTopLeftRadius: isOwnMessage ? null : 0,
      boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
      marginBottom: 1,
    }}
  >
    <Skeleton variant="text" width="100%" height={40} />
  </Box>
);

export const SkeletonLinkPreview = ({ isOwnMessage }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        mt: 1,
        border: '1px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        width: isMobile ? '65vw' : '300px',
        marginBottom: 2,
        marginLeft: isOwnMessage ? 'auto' : 0,
        marginRight: isOwnMessage ? 0 : 'auto',
        borderTopRightRadius: isOwnMessage ? 0 : null,
        borderTopLeftRadius: isOwnMessage ? null : 0,
      }}
    >
      <Skeleton variant="rectangular" width={300} height={150} />
      <Box sx={{ padding: '8px' }}>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="60%" sx={{ mt: 0.5 }} />
      </Box>
    </Box>
  );
};
